import { useEffect, useState } from "react";

const menu = [
  { label: "회사소개", href: "#about" },
  { label: "업무절차", href: "#process" },
  { label: "업무영역", href: "#services" },
  { label: "성공사례", href: "#cases" },
  { label: "대표링크", href: "#contact" },
  { label: "상담신청", href: "#inquiry" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <a href="#top" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/2836f450-9c16-4795-8079-772e594f98c3/17d34460-be96-4079-86f8-0948b01a564e_compressed__.webp"
            alt="다다손해사정"
            className={`h-9 w-auto object-contain transition-opacity duration-300 ${
              scrolled ? "opacity-100" : "opacity-90"
            }`}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {menu.map((m) => (
            <a
              key={m.label}
              href={m.href}
              className={`nav-link text-sm font-medium tracking-wide cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-foreground-800 hover:text-primary-600"
                  : "text-foreground-800 hover:text-primary-600"
              }`}
            >
              {m.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:010-2696-9689"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold px-5 py-2.5 rounded-full transition whitespace-nowrap cursor-pointer"
          >
            상담신청
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-950`}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-6 py-6">
          <nav className="flex flex-col gap-4">
            {menu.map((m) => (
              <a
                key={m.label}
                href={m.href}
                onClick={() => setOpen(false)}
                className="text-foreground-900 font-medium text-base cursor-pointer"
              >
                {m.label}
              </a>
            ))}
            <a
              href="tel:010-2696-9689"
              onClick={() => setOpen(false)}
              className="mt-2 bg-primary-500 text-background-50 text-center font-semibold py-3 rounded-full cursor-pointer whitespace-nowrap"
            >
              상담신청
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}